var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course-info__seo pa-0"},[_c('seo-form',{ref:"seoForm",attrs:{"entryLocales":_vm.basicLocales,"locale":_vm.basicLocales[0].locale,"content":_vm.seo,"contentLoading":_vm.seoLoading,"updateLoading":_vm.updateSeoLoading},on:{"on-submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }